import { render, staticRenderFns } from "./TeamInvitationItem.vue?vue&type=template&id=3da1f5d8&"
import script from "./TeamInvitationItem.vue?vue&type=script&lang=ts&"
export * from "./TeamInvitationItem.vue?vue&type=script&lang=ts&"
import style0 from "./TeamInvitationItem.vue?vue&type=style&index=0&id=3da1f5d8&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports